// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonRoles = {
  admin: "管理者",
  question_editor: "問題編集者",
  exam_manager: "試験管理者",
  reviewer: "採点者",
  proctor: "監督者",
  candidate: "受験者",
  platform_user: "プラットフォームユーザー",
} as const;
